import * as S from "./dataItemBox.styles";

export interface DataItemProps {
  label?: string;
  content?: string | number;
  route?: boolean;
  fontWeight?: string;
  fontSize?: string;
  dateFontSize?: string;
  dispatchDate?: boolean;
}

export const DataItemBox = ({
  label,
  content,
  route,
  fontWeight,
  fontSize,
  dateFontSize,
  dispatchDate,
}: DataItemProps) => {
  return (
    <S.DataItemBox route={route ? true : false} fontWeight={fontWeight}>
      <S.DataLabelSpan fontSize={fontSize}>{label}</S.DataLabelSpan>

      <S.DataContentBox
        dateFontSize={dateFontSize}
        className={dispatchDate ? "dispatchDate" : ""}
      >
        {content ? content : "-"}
      </S.DataContentBox>
    </S.DataItemBox>
  );
};
